var map = {
	"./animacion1.gif": 2053,
	"./animacion2.gif": 3370,
	"./animacion3.gif": 435,
	"./arrastrarVideoNuevo.gif": 7979,
	"./circuit-board.gif": 9141,
	"./html.gif": 5882,
	"./idea.gif": 3316,
	"./image_signup_step2.gif": 6194,
	"./imagenAnimadaNueva.gif": 3766,
	"./img_signin-signup.gif": 1488,
	"./linebotExplorar.gif": 7859,
	"./loading.gif": 2375,
	"./videoFuncionalRaspi.gif": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5670;